<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div mat-dialog-title>
  {{ data?.duty?.id ? 'Edit Duty' : 'Add Duty' }}
  <button
    mat-icon-button
    (click)="handleEditComplete(false)"
    title="Cancel"
    class="close-button"
    tabindex="-1"
    >
    <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
  </button>
</div>
@if (data && data.duty) {
  <div mat-dialog-content>
    <div class="add-margin">
      <div>
        <mat-form-field class="name-field full-width">
          <mat-label>Duty Name</mat-label>
          <input matInput [(ngModel)]="data.duty.name" [disabled]="!data.canEdit" />
        </mat-form-field>
      </div>
    </div>
    @if (data.teamList) {
      <div class="add-margin">
        <div>
          <mat-form-field class="button-margins full-width">
            <mat-label>Team</mat-label>
            <mat-select placeholder="Team" [(ngModel)]="data.duty.teamId" [disabled]="!data.canEdit">
              @if (!data.duty.id && data.teamList.length > 1) {
                <mat-option value="">All Teams</mat-option>
              }
              @for (team of data.teamList; track team) {
                <mat-option [value]="team.id">
                  {{ team.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }
    <div class="cssLayoutRowStartCenter bottom-button">
      <div class="delete-button">
        <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!errorFree() || !data.canEdit" style="margin-left: 40px;">Save</button>
      </div>
      <div class="delete-button">
        <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
      </div>
    </div>
  </div>
}
